import React, { createContext, useContext } from 'react';

export interface AnalyticsProperties {
  page?: string;
  action?: string;
  category?: string;
  element?: string | null;
  properties?: Record<string, unknown>;
}

export type TrackFn<T = AnalyticsProperties> = (properties?: T) => void;

export interface AnalyticsContextValue {
  track: TrackFn;
}

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(
  null
);

if (process.env.NODE_ENV === 'development') {
  AnalyticsContext.displayName = 'AnalyticsContext';
}

export function useStravaAnalytics() {
  const context = useContext(AnalyticsContext);

  if (!context) {
    throw new Error(
      'useStravaAnalytics must be used within the AnalyticsProvider'
    );
  }

  return context;
}

export interface AnalyticsProviderProps extends AnalyticsContextValue {
  children: React.ReactNode;
}

export const AnalyticsProvider = ({
  children,
  ...analyticsContextValue
}: AnalyticsProviderProps) => {
  return (
    <AnalyticsContext.Provider
      value={{
        ...analyticsContextValue
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

if (process.env.NODE_ENV === 'development') {
  AnalyticsProvider.displayName = 'AnalyticsProvider';
}
